export enum Role {
  Admin = 'admin',
  Offical = 'offical',
  Organization = 'association',
  OrganizationJudge = 'judge',
  Verified = 'verified',
  UserAccount = 'userAccount',
  HWJudge = 'hw_judge',
  CompetitionManager = 'competition_manager',
}

export type IRole = {
  [index in keyof typeof Role]: boolean
}
